// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__32P5s","productName":"Table_productName__3OGoF"};